import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

const summaryStyles = `
@keyframes ps-glow { 0%,100%{box-shadow:0 0 0 0 var(--gc,rgba(24,144,255,.35))} 50%{box-shadow:0 0 0 8px rgba(0,0,0,0)} }

.ps-wrap { margin:0 0 16px 0; }
.ps-title { font-size:11px; font-weight:700; color:#1890ff; letter-spacing:1px; text-transform:uppercase; margin-bottom:10px; display:flex; align-items:center; gap:6px; }

.ps-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:10px; }
@media(max-width:600px){ .ps-grid { grid-template-columns:1fr; } }

.ps-card { border-radius:8px; border:1px solid #e6f0ff; background:#fff; padding:12px 14px; display:flex; flex-direction:column; gap:4px; }
.ps-card-label { font-size:10px; font-weight:700; color:#8c8c8c; letter-spacing:.6px; text-transform:uppercase; }
.ps-card-value { font-size:15px; font-weight:700; color:#262626; }

/* Special cards */
.ps-card-warn { border-color:#ffd591; background:#fffbe6; }
.ps-card-warn .ps-card-value { color:#d46b08; }
.ps-card-info { border-color:#d6e8ff; background:#f0f7ff; }
.ps-card-info .ps-card-value { color:#0050b3; }
.ps-card-success { border-color:#b7eb8f; background:#f6ffed; }
.ps-card-success .ps-card-value { color:#389e0d; }
.ps-card-danger { border-color:#ffa39e; background:#fff1f0; }
.ps-card-danger .ps-card-value { color:#cf1322; }

/* Existing RM badge */
.ps-rm-yes { display:inline-flex; align-items:center; gap:5px; padding:2px 10px; border-radius:10px; background:#fff1f0; border:1px solid #ffa39e; font-size:12px; font-weight:800; color:#cf1322; }
.ps-rm-none { display:inline-flex; align-items:center; gap:5px; padding:2px 10px; border-radius:10px; background:#f6ffed; border:1px solid #b7eb8f; font-size:12px; font-weight:700; color:#389e0d; }
.ps-rm-dot { width:6px; height:6px; border-radius:50%; flex-shrink:0; }
`;

const PrSummary = ({ prTotal, withExistingRm, itemTotalBudget }) => {
  const itemTotalWithMargin =
    itemTotalBudget > 0 ? (itemTotalBudget * 1.2).toFixed(2) : 0;

  const diff = itemTotalWithMargin
    ? Math.abs(itemTotalWithMargin - prTotal).toFixed(2)
    : null;

  const diffPct = itemTotalWithMargin
    ? (((itemTotalWithMargin - prTotal) / itemTotalWithMargin) * 100).toFixed(2)
    : null;

  const diffLabel = diff
    ? `${diff} (${diffPct}%)`
    : 'No total budget price';

  const diffPositive = diff && (itemTotalWithMargin - prTotal) >= 0;

  return (
    <>
      <style>{summaryStyles}</style>
      <div className="ps-wrap">
        <div className="ps-title">
          <Icon type="bar-chart" />
          Summary
        </div>

        <div className="ps-grid">
          {/* Existing RM */}
          <div className={`ps-card ${withExistingRm ? 'ps-card-danger' : 'ps-card-success'}`}>
            <span className="ps-card-label">Existing Raw Materials Purchases</span>
            {withExistingRm
              ? <span className="ps-rm-yes"><span className="ps-rm-dot" style={{ background:'#ff4d4f', boxShadow:'0 0 5px #ff4d4f' }} />YES</span>
              : <span className="ps-rm-none"><span className="ps-rm-dot" style={{ background:'#52c41a', boxShadow:'0 0 5px #52c41a' }} />NONE</span>
            }
          </div>

          {/* PR Total */}
          <div className="ps-card ps-card-info">
            <span className="ps-card-label">Purchase Request Total</span>
            <span className="ps-card-value">{prTotal}</span>
          </div>

          {/* Budget + margin */}
          <div className="ps-card ps-card-warn">
            <span className="ps-card-label">Item Total Budget + 20% Margin</span>
            <span className="ps-card-value">{itemTotalWithMargin || '—'}</span>
          </div>

          {/* Difference */}
          <div className={`ps-card ${diff ? (diffPositive ? 'ps-card-success' : 'ps-card-danger') : 'ps-card'}`}>
            <span className="ps-card-label">Difference (Budget vs PR Total)</span>
            <span className="ps-card-value">{diffLabel}</span>
          </div>
        </div>
      </div>
    </>
  );
};

PrSummary.propTypes = {
  prTotal:         PropTypes.number.isRequired,
  withExistingRm:  PropTypes.bool.isRequired,
  itemTotalBudget: PropTypes.number.isRequired,
};

export default PrSummary;